/**
 * Decor Management Module
 */
import Konva from "konva";

export class DecorManager {
	constructor(stageManager, appState) {
		this.stageManager = stageManager;
		this.appState = appState;
	}

	/**
	 * Load decors from server
	 */
	loadDecors(categorySlug) {
		const $list = jQuery(".mc-decor-list");
		$list.addClass("is-loading");

		return new Promise((resolve) => {
			jQuery.ajax({
				url: window.MC_DATA.ajax_url,
				type: "GET",
				dataType: "json",
				data: {
					action: "mc_get_decors",
					nonce: window.MC_DATA.decor_nonce,
					category: categorySlug || "",
				},
				success: (resp) => {
					if (resp && resp.success && resp.data && resp.data.items) {
						this.renderDecorList(resp.data.items);
					}
					$list.removeClass("is-loading");
					resolve();
				},
				error: () => {
					$list.removeClass("is-loading");
					resolve();
				},
			});
		});
	}

	/**
	 * Render decor list
	 */
	renderDecorList(items) {
		const $list = jQuery(".mc-decor-list");
		$list.empty();

		if (!items.length) {
			$list.append(
				'<div class="mc-decor-empty">Nėra dekorų šioje kategorijoje.</div>'
			);
			return;
		}

		items.forEach((item) => {
			const $item = jQuery("<div class='mc-decor-item'></div>")
				.attr("data-id", item.id)
				.attr("data-image", item.image)
				.attr("data-title", item.title);

			if (item.thumb) {
				$item.append(
					jQuery("<img>")
						.attr("src", item.thumb)
						.attr("alt", item.title)
				);
			}

			$item.append(
				jQuery("<div class='mc-decor-title'></div>").text(item.title)
			);

			$list.append($item);
		});
	}

	/**
	 * Add decor image to canvas
	 */
	addDecorImageToCanvas(src, title) {
		const stage = this.stageManager.getStage();
		const mainLayer = this.stageManager.getMainLayer();
		const transformer = this.stageManager.getTransformer();

		const img = new window.Image();
		img.onload = () => {
			const w = img.width;
			const h = img.height;
			const maxW = stage.width() * 0.25;
			const baseScale = w > maxW ? maxW / w : 1;
			const scale = baseScale * 0.5; // Reduce default size by half for better fit
			const dispW = w * scale;
			const dispH = h * scale;

			const node = new Konva.Image({
				image: img,
				x: stage.width() / 2 - dispW / 2,
				y: stage.height() / 2 - dispH / 2,
				width: dispW,
				height: dispH,
				draggable: true,
				name: "mc-decor",
				decorTitle: title || "",
			});

			// Store initial state for reset
			node.setAttr("initialWidth", dispW);
			node.setAttr("initialHeight", dispH);
			node.setAttr("baseScaleX", 1);
			node.setAttr("baseScaleY", 1);
			node.setAttr("baseRotation", 0);
			node.setAttr("baseX", node.x());
			node.setAttr("baseY", node.y());

			mainLayer.add(node);
			mainLayer.draw();

			const selectNode = (evt) => {
				if (window.mcSetActiveElement) {
					window.mcSetActiveElement(node, {
						multiSelect: this.isMultiSelectGesture(evt),
					});
				}

				this.stageManager.setPhotosNotActive();

				transformer.nodes([node]);
				transformer.keepRatio(true);
				transformer.enabledAnchors([
					"top-left",
					"top-right",
					"bottom-right",
					"bottom-left",
				]);
				mainLayer.draw();
			};

			const handleDragStart = () => {
				jQuery(".mc-element-toolbar[data-mode='image']").hide();
			};

			selectNode();

			node.on("click tap", selectNode);
			node.on("dragstart", handleDragStart);
			node.on("dragend", selectNode);
		};
		img.src = src;
	}

	isMultiSelectGesture(evt) {
		const nativeEvent = evt && evt.evt ? evt.evt : evt;
		if (!nativeEvent) return false;
		return Boolean(
			nativeEvent.shiftKey || nativeEvent.metaKey || nativeEvent.ctrlKey
		);
	}
}
